// removed by extract-text-webpack-plugin
module.exports = {"main-text-color":"#1c1b1c","btn-default-bg-color":"#f4f4f4","btn-default-border-color":"#969696","btn-default-bg-hover-color":"#e3e3e3","btn-primary-bg-color":"#8c1515","btn-primary-bg-hover-color":"#d32424","inverse-main-text-color":"#fffeff","btn-info-bg-color":"#5ac0cc","btn-info-bg-hover-color":"#45D3E3","btn":"_3yT2PZ_shJDqEdEntOrpfy","largeSzBtn":"_3_ulunJwW0s2dWPY7xMz1B","normalSzBtn":"_1x979ttn11xVmbx0Xk6HLI","smallSzBtn":"wyJR160ksVsWbmHkEId4n","primaryBtn":"lRZGWusKfRCeCHkfGR5zR","infoBtn":"QzUe-9ulMQWQFyjqhGJ57","pullRight":"_12A557qbcVVoCVGUPzsh3X"};


//////////////////
// WEBPACK FOOTER
// ./src/views/fragments/button/style.css
// module id = 715
// module chunks = 0